module.exports = __webpack_public_path__ + "static/media/make-time.32bacf15.jpg";